import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    form: {
      id: '1',
      status: '1'
    },
    fields: [
      { id: '1', type: 'text', label: 'Test', placeholder: 'Insert data here', required: '1' },
      { id: '2',
        type: 'dropdown',
        label: 'Test2',
        placeholder: '',
        required: '0',
        options: [
          'Option1',
          'Option2'
        ]
      }
    ],
    limit: {
      option: 500,
      option_character: 100,
      option_checkbox_radio: 10,
      placeholder: 100
    },
    link_manual: {
      th: process.env.MANUAL_URL_TH + '#form',
      en: process.env.MANUAL_URL_EN + '#form',
      vi: process.env.MANUAL_URL_VI + '#form'
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/index.js